import { PreRenderService } from '../../services/pre-render.service';
import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';


/**
 * Adds the template content to the DOM only if the platform is the requested platform
 */
@Directive({
    selector: '[ifPlatform]'
})
export class IfPlatformDirective {
  private _hasView = false;

  constructor(
    private _templateRef: TemplateRef<any>,
    private _viewContainer: ViewContainerRef,
    private prerenderService: PreRenderService
  ) { }

  @Input() set ifPlatform(platform: 'browser' | 'server') {

    const satisfied = (platform == 'browser' && this.prerenderService.isBrowserMode)
    || (platform == 'server' && this.prerenderService.isServerMode);
    if (satisfied && !this._hasView) {
      this._viewContainer.createEmbeddedView(this._templateRef);
      this._hasView = true;
    } else if (!satisfied && this._hasView) {
      this._viewContainer.clear();
      this._hasView = false;
    }
  }
}
